import React, { memo } from 'react';
import { getPlatformStyles } from '@direct-frontend/platform-code';

import { Image } from '../Image/Image';
import { IconSize } from '../../icons/types';
import { cn } from '../../lib/css/className/className';

import { InfoBaseCloseButton } from './InfoBaseCloseButton';

getPlatformStyles({
    common: import('./InfoBase.css'),
});

const cls = cn('InfoBaseImage');

export interface InfoBaseImageProps {
    /**
     * Источник изображения
     */
    imageSrc: string;

    /**
     * Альтернативный текст изображения
     */
    imageAlt: string;

    /**
     * Обработчик закрытия (если есть, показывается кнопка закрытия)
     */
    onClose?: () => void;

    /**
     * Текст для кнопки закрытия
     */
    closeButtonText: string;

    /**
     * Размер иконки закрытия
     */
    iconSize: IconSize;

    /**
     * CSS класс для контейнера
     */
    className?: string;

    /**
     * CSS класс для изображения
     */
    imageClassName?: string;

    /**
     * CSS класс для кнопки закрытия
     */
    closeButtonClassName?: string;

    /**
     * data-testid для тестирования
     */
    dataTestId?: string;
}

/**
 * Компонент для отображения полноэкранного изображения с плавающей кнопкой закрытия.
 */
export const InfoBaseImage = memo<InfoBaseImageProps>(function InfoBaseImage({
    imageSrc,
    imageAlt,
    onClose,
    closeButtonText,
    iconSize,
    className,
    imageClassName,
    closeButtonClassName,
    dataTestId,
}) {
    return (
        <div className={cls(null, [className])}>
            <Image
                width="auto"
                height="100%"
                src={imageSrc}
                alt={imageAlt}
                className={cls('image', [imageClassName])}
            />
            <InfoBaseCloseButton
                onClose={onClose}
                closeButtonText={closeButtonText}
                iconSize={iconSize}
                variant="floating"
                className={cls('closeButton', [closeButtonClassName])}
                dataTestId={dataTestId}
            />
        </div>
    );
});
